<div class="container dashboard_card fm_padding dc_fixed" *ngIf="show_verify">

  <div class="dc_header">
      <span></span>
      <h3>Verify</h3>
      <button (click)="show_verify=false"><i class="icon-close"></i></button>
  </div>

  <div class="add_cust_card">
            
            <div class="acc_show_card">

                <div class="lcta_tbox" [ngClass]="{'error': this.state.verifylistval.iserr}">
                  <ng-container *ngFor="let obj of this.state.VerifyList">
                    <div class="radio_card"> <input type="radio" name="verifyradio_RadioList"
                        group="verify_RadioList" id="div_verifyradio_RadioList_{{obj.id}}"
                        [(ngModel)]="state.verifylistval.value"
                        [value]="obj"
                      (change)="state.verifylistval.iserr=false"
                        />
                    <label for="div_verifyradio_RadioList_{{obj.id}}">{{obj.name}}</label>
                    </div>
                  </ng-container>
                <span class="error_txt" *ngIf="state.verifylistval.iserr">{{state.verifylistval.err_txt}}</span>
              </div>
              
            
            <div class="textarea_card">
                <span>Comments</span>
                <textarea name="" placeholder="Comments"  cols="30" rows="10"  [(ngModel)]=this.state.comments.value></textarea>
            </div>

          </div>
    </div>

    <button (click)="$event.stopPropagation();varify_check()" class="fixed_btn">YES</button>

</div>
 
